import { get, put, post, del } from './connection'
const jobApi = {
    getAllJobDetails: async (queryString) => {
        try {
            return get("/jobdetails/get-all-jobdetail"+ queryString);
        } catch (error) {
            throw new Error("Error while fetching job details");
        }
    },
    createJobDetails: async (requestData) => {
        try {            
            const response = post("/jobdetails/add-jobdetail", requestData);
            return response;
        } catch (error) {
            throw new Error("Error while creating job details");
        }
    },
    updateJobDetails: async (requestData) => {
        try {            
            const response = put("/jobdetails/edit-jobdetail/"+ requestData.jobDetailId, requestData);
            return response;
        } catch (error) {
            throw new Error("Error while creating job details");
        }
    },
    updateFilledPositions: async (id, requestData) => {
        try {            
            const response = put("/jobdetails/edit-jobpostion/"+ id, requestData);
            return response;
        } catch (error) {
            throw new Error("Error while updating job filled positions");
        }
    },
    deleteJobDetails:async (jobDetailId) => {
        try {            
            const response = del("/jobdetails/delete-jobdetail/"+ jobDetailId);
            return response;
        } catch (error) {
            throw new Error("Error while deleting job details");
        }
    },
    getJobDetailById: async (id) => {
        try {            
            return get(`/jobdetails/get-jobdetail-by-id/${id}`);
        } catch (error) {

            throw new Error("Error while selecting job detail");
        }
    },
    getJobOverViewById: async (id) => {
        try {            
            return get(`/jobdetails/get-job-overview/${id}`);
        } catch (error) {

            throw new Error("Error while selecting job overview");
        }
    },
    getMappedCandidateDetailsByJobId: async (id) => {
        try {            
            return get(`/jobdetails/get-mapped-candidatedetail-by-jobid/${id}`);
        } catch (error) {

            throw new Error("Error while selecting mapped candidate details");
        }
    },
    
    getMappingDetailswithBoardDetailsByJobId: async (id,boardId,queryString, boardLimitDay) => {
        try {     
            //return get("/jobcandidatemapping/get-mappingdetailsandboarddetails-by-jobid?jobId="+id + "&boardId="+boardId+"&searchText="+ searchText);     
            return get(`/jobcandidatemapping/get-mappingdetailsandboarddetails-by-jobid/${id}/${boardLimitDay}/${boardId}`+ queryString);
        } catch (error) {
            throw new Error("Error while selecting mapping and board details");
        }
    },
    updateBoardMapping: async (requestData) => {
        try {            
            const response = post(`/jobcandidatemapping/add-job-candidate-mapping`,requestData);
            return response;
        } catch (error) {

            throw new Error("Error while updating mapping and board details");
        }
    },
    updateCandidateAssignee: async (requestData) => {
        // debugger;
        try {            
            const response = post(`/jobcandidatemapping/add-candidate-assignee-mapping`,requestData);
            return response;
        } catch (error) {
            throw new Error("Error while updating mapping and board details");
        }
    },
    getJobOverViewCountByJobId: async (jobId) => {
        try {            
            const response = get(`/jobdetails/get-overview-counts-by-jobid/${jobId}`);
            return response;
        } catch (error) {
            throw new Error("Error while fetching job overview details");
        }
    },
    getActiveJobsOverviewCount: async (queryString) => {
        try {            
            const response = get(`/jobdetails/get-active-jobs-overview-count${queryString}`);
            return response;
        } catch (error) {
            throw new Error("Error while fetching active jobs overview details");
        }
    },

    deleteBoard: async (boardId) => {
        try {
            const response = post(`/jobcandidatemapping/delete-board/${boardId}`);
            return response;
        } catch (error) {
            throw new Error("Error while deleting board");
        }
    },

    approveJob: async (id) => {
        debugger
        try {      
            return put("/jobdetails/approve-job-by-id/"+ id);  
        } catch (error) {

            throw new Error("Error while selecting job detail");
        }
    },
    
    
};

export default jobApi;